var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{ref:"tinymce",staticClass:"vue-tinymce",attrs:{"id":_vm.id,"name":_vm.name,"placeholder":_vm.placeholder}},[_vm._v("      "+_vm._s(_vm.content)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }